import React, { useEffect, useState } from 'react';
import { useParams, useOutletContext } from 'react-router-dom';
import './TaxRollPage.css'; // Your custom styling
import TaxRollInfo from './TaxRollInfo';

// Helper function: Convert 2-digit year to 4-digit year.
function toFourDigitYear(twoDigitYear) {
  const yearNum = parseInt(twoDigitYear, 10);
  // Adjust the pivot (50) as needed for your use case
  if (yearNum < 50) {
    // e.g. "23" → 2023
    return 2000 + yearNum;
  } else {
    // e.g. "99" → 1999
    return 1900 + yearNum;
  }
}

const TaxRollPage = () => {
  const { customerId, taxid, taxyear } = useParams();
  const { dataClient, dataProperty } = useOutletContext();

  const [dataTax, setDataTax] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTaxData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_PROXY_URL}/api/taxPropertyDetail/${customerId}/${taxid}/${taxyear}`
        );
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const result = await response.json();
        setDataTax(result.data?.result || result); // Safely access nested data
      } catch (error) {
        console.error('Error fetching tax data:', error);
        setError(error);
      }
    };

    fetchTaxData();
  }, [customerId, taxid, taxyear]);

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  if (!dataTax) {
    return <div>Loading...</div>;
  }

  // Calculate total of the "Taxable/$" column
  const totalTaxable = dataTax.reduce((acc, item) => {
    const taxableVal = parseFloat(item.taxable) || 0;
    return acc + taxableVal;
  }, 0);

  // Convert the 2-digit taxyear to a 4-digit display year
  const displayYear = toFourDigitYear(taxyear);

  return (
    <div className="container">
      <div className="content">
        {dataProperty ? (
          <TaxRollInfo dataProperty={dataProperty} />
        ) : (
          <div>Loading...</div>
        )}
      </div>

      <table className="responsive-table">
        <thead>
          <tr>
            {/* 6 columns total */}
            <th colSpan={2}>Class</th>
            {/* <th>Description</th> */}
            <th>District</th>
            <th>Quantity</th>
            <th>Market</th>
            <th>Taxable/$</th>
            <th nowrap>Assessed Tax</th>
          </tr>
        </thead>
        <tbody>
          {dataTax.map((item, index) => (
            <tr key={index}>
              <td>{item.classClass}</td>
              <td>{item.description.trim()}</td>
              <td>{item.district.trim()}</td>
              <td>{item.quantity.toFixed(2)}</td>
              <td>{item.marketValue.toLocaleString(undefined, { minimumFractionDigits: 2 })}</td>
              <td>{item.taxable.toLocaleString(undefined, { minimumFractionDigits: 2 })}</td>
              <td>{item.billAmount.toLocaleString(undefined, { minimumFractionDigits: 2 })}</td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr>
            {/* Combine the first 5 columns for the totals label */}
            <td colSpan={5}>Totals for {displayYear}</td>
            {/* 6th column displays the sum */}
            <td>{totalTaxable.toLocaleString(undefined, { minimumFractionDigits: 2 })}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
};

export default TaxRollPage;